import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ToasterService, BodyOutputType } from 'angular2-toaster';
import { environment } from '../environments/environment';
import { Observable, Subscription } from 'rxjs';
import * as moment from 'moment';
import { IMyDpOptions } from 'mydatepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { Batch, Bin, EOD, Job, Order, Setting, Shipment, ActivityHistory } from './models';

import {
  CREATE_JOBS,
  CREATE_ORDER,
  CREATE_SETTING,
  CREATE_TEMPLATE,
  CREATE_USER,
  DELETE_SETTING,
  DELETE_TEMPLATE,
  DELETE_USER,
  GET_SETTINGS,
  GET_TEMPLATE_PDFS,
  GET_TEMPLATES,
  GET_USERS,
  SET_MAIN_VIEW,
  SET_SETTING_LIST_VIEW,
  SET_TEMPLATE_EDIT_FORM,
  SET_TEMPLATE_LIST_VIEW,
  SET_TEMPLATE_OVERLAY_VIEW,
  SET_USER_LIST_VIEW,
  UPDATE_SETTING,
  UPDATE_TEMPLATE,
  UPDATE_USER,
  SET_JOB_DETAILS_VIEW,
  SET_JOB_SHIP_FLAG
} from '../ngrx/actions';

import {
  BATCH_CUTTING,
  COMPLETED,
  EOD_FAILED,
  HOLD,
  OTHER,
  SHIPPED,
  HANDHELD,
  STATIONARY,
  nextStatus,
  nextOAStatus,
  EOD_COMPLETED,
  PRINTED,
  CANCELLED,
  PRINTING,
  PRINT_READY,
  allowJobScan,
  SHIPPING,
  SHIPMENTS,
  CUT,
  PENDING_PRINTING,
  NEW
} from '../ngrx/status-types';

import { OA, RFID, SHEETS } from '../ngrx/category-types';
import { DB_ID_TO_MACHINE_NAME_MAPPING } from '../ngrx/existingmachines';
import { TranslateService } from './i18n';
import {
  AuthenticationService,
  CredentialService,
  EODService,
  MQTTService,
  OrderService,
  PrinterService,
  SettingService,
  ShipmentService,
  ScannerService,
  TemplateService,
  JobService
} from './services';
import { SheetCountModal } from './shared/modals/sheet-count-modal/sheet-count-modal.component';
import { PendingPrintCsModal } from './shared/modals/pending-print-cs-modal/pending-print-cs-modal.component';
import { EditadoSheetQaModal } from './shared/modals/editado-sheet-qa-modal/editado-sheet-qa-modal.component';
import { QaOkayModal } from './shared/modals/qa-okay-modal/qa-okay-modal.component';

@Component({
  // tslint:disable-next-line
  selector   : 'body',
  templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('boxingStationPrompt') boxingStationPrompt;
  @ViewChild('eodModal') eodModal;
  @ViewChild('globalModal') globalModal;
  @ViewChild('invalidScanModal') invalidScanModal;
  @ViewChild('intlInvoiceConfirmModal') intlInvoiceConfirmModal;
    // allowEod              : boolean;
  batchList                 : Observable<Batch[]>;
  batchListView             : Observable<any>;
  batchesMissingScrap       : Batch[];
  binList                   : Observable<Bin[]>;
  boxingStationForm         : FormGroup;
  boxingStationPromptRef    : BsModalRef;
  boxingStationToggle       : boolean;
  datePickerOptions         : IMyDpOptions = {};
  eodForm                   : FormGroup;
  eodList                   : Observable<EOD[]>;
  eodModalRef               : BsModalRef;
  eodOAProcessing           : boolean;
  eodProcessing             : boolean;
  eodRFIDProcessing         : boolean;
  eodReady                  : boolean;
  globalModalRef            : BsModalRef;
  QaOkayModalRef            : BsModalRef;
  globalModalTitle          : string;
  globalModalBody           : string;
  globalModalClass          : string;
  invoiceDone               : boolean;
  intlInvoiceConfirmModalRef: BsModalRef;
  intlShipment              : any;
  invalidScanModalRef       : BsModalRef;
  sheetCountModalRef        : BsModalRef;
  pendingPrintingCsModalRef : BsModalRef;
  sheetEstimate             : string;
  defaultLanguage = 'EN';
  jobList                 : Observable<Job[]>;
  jobs                    : Job[];
  mailInnovationsOrderList: Observable<any>;
  mainView                : Observable<any>;
    // minDate                 : Date;
  order               : any;
  orderList           : Observable<Order[]>;
  printingInvoice     : boolean;
  scanErrJob          : Job;
  scanErrJobHoldReason: any;
  settingList         : Observable<Setting[]>;
  shipment            : any;
  shipmentList        : Observable<Shipment[]>;
  shipmentsReady      : boolean;
  language            : string;
  id = '';
  process             : string;
  unassignedMIDOrders: boolean;
  userListView       : Observable<any>;
  initSubscriptions  : Subscription[];
  jobShipFlagView    : Observable<any>;
  jobShipFlag        : boolean;
  currentCarrier     : string;
  carrierTypes       : string[] = [];
  DB_ID_TO_MACHINE_NAME_MAPPING = DB_ID_TO_MACHINE_NAME_MAPPING;

  constructor(
    private authService      : AuthenticationService,
    private credentialService: CredentialService,
    private fb               : FormBuilder,
    private eodService       : EODService,
    private mqttService      : MQTTService,
    private modalService     : BsModalService,
    private orderService     : OrderService,
    private printerService   : PrinterService,
    private router           : Router,
    private scanner          : ScannerService,
    private settingService   : SettingService,
    private shipmentService  : ShipmentService,
    private store            : Store<any>,
    private templateService  : TemplateService,
    private toasterService   : ToasterService,
    private translate        : TranslateService,
    private jobService        : JobService
  ) {
    this.batchList                = this.store.select('batches', 'batchList');
    this.batchListView            = this.store.select('batches', 'batchListView');
    this.binList                  = this.store.select('bins', 'binList');
    this.eodList                  = this.store.select('eod', 'eodHistory');
    this.jobList                  = this.store.select('jobs', 'jobList');
    this.mailInnovationsOrderList = this.store.select('orders', 'mailInnovationsOrderList');
    this.mainView                 = this.store.select('main', 'mainView');
    this.orderList                = this.store.select('orders', 'orderList');
    this.settingList              = this.store.select('settings', 'systemSettingList');
    this.shipmentList             = this.store.select('shipments', 'shipmentList');
    this.userListView             = this.store.select('users', 'userListView');
    this.jobShipFlagView          = this.store.select('jobs', 'jobShipFlagView');
  }

  public logout(): void {
    this.authService.logout();
  }

  ngOnInit() {
    if (environment.production) {
      // window.console.log = function (){};
    }

    this.credentialService.initialize();

    this.language = localStorage.getItem('language');

    this.translate.setDefaultLang(this.defaultLanguage);
    this.translate.enableFallback(true);
    this.translate.use(this.language || this.defaultLanguage);

    this.createForms();

    this.printerService.setQZCredentials();
    this.printerService.startConnection({ retries: 5, delay: 1 });

    window.addEventListener('keypress', ({ key }) => {
      this.scanner.push(key);

      if (this.scanner._locationListening) {
        console.log(`Start scanning job/order context`);

        if (this.scanner.listenerTrigger(this.scanner._types)) {
          console.log(`Done scanning job/order ID`);
          this.scanner._printingScanListener.next(this.id);
          this.scanner._qaScanListener.next(this.id);
          this.scanner._laminationScanListener.next(this.id); // This modal is for RFIND bulk selection to update jobs
          // this.scanner._changeCutMachineScanListener.next(this.id); // This modal is for OA bulk selection to update jobs to laser/horizon machine
          this.scanner._accessoryScanListener.next(this.id); //Disabled - Scanners needs to be setup
          this.scanner._rfidScanListener.next(this.id);
          this.scanner._locationListener.next(this.id);
          this.scanner._locationToggle.next(false);
          this.id = '';
          
          // If we want to extend this for all systems (SHEETS, OA) currently I just check within RFID to be more specific
          // // Skip processing if scanner is in exclusive mode
          // if (this.scanner.isExclusiveMode()) {
          //   this.scanner._locationListener.next(this.id);
          //   console.log('Scanner in exclusive mode, skipping global location listener logic');
          // }
        
        }

        if (!this.scanner._locations[key]) {
          this.id += key;
        }
      }


      // if (this.scanner._jobIDListening) {
      //   console.log('Start scanning Job ID!');
      //   if (this.scanner.isEqualTo(this.scanner._jobIDStop)) {
      //     console.log('Done scanning Job ID');
      //     this.scanner._jobIDListener.next(this.jobID);
      //     this.scanner._jobIDListening = false;
      //     console.log(`Job ID: ${this.jobID}`);
      //     this.jobID = '';
      //   }
      //   if (!this.scanner._jobIDStart.find(char => char === key)) {
      //     this.jobID += key;
      //   }
      // }
    });

    this.store.dispatch({
      type: SET_SETTING_LIST_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_TEMPLATE_LIST_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_TEMPLATE_EDIT_FORM,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_TEMPLATE_OVERLAY_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_USER_LIST_VIEW,
      payload: {
        loading           : true,
        userDetailsLoading: true
      }
    });

    this.initSubscriptions = [
      this.mainView
        .subscribe(({ process, printingInvoice }) => {
          this.process = process;
          this.printingInvoice = printingInvoice;
          if(process === 'rfid') {
            this.carrierTypes = [ 'UPS', 'FEDEX', 'LTL' ];
          } else {
            this.carrierTypes = [ 'UPS', 'FEDEX', 'AMAZON' ];
          }
        }),

      this.mqttService
        .sessionListener
        .subscribe(({ payload }) => {
          if (payload && payload === "LOGOUT") {  
            this.logout();
          }
        }),

      this.mqttService
        .settingListener
        .subscribe(({ payload }) => {
          const { type, id, ids, diffList, setting, stage } = payload;

          switch (type) {
            case CREATE_SETTING: 
              if (id && stage === environment.stage && setting) {
                console.log(`CREATE SETTING RESPONSE`);
                console.log(payload);

                this.store.dispatch({
                  type: CREATE_SETTING,
                  payload: { setting }
                });

                console.log(`MQTT: Setting ${id} created!`);
              }
              break;
            case DELETE_SETTING: 
              if (id && stage === environment.stage) {
                console.log(`DELETE SETTING RESPONSE`);
                console.log(payload);

                this.store.dispatch({
                  type   : DELETE_SETTING,
                  payload: { id }
                });

                console.log(`MQTT: Setting ${id} deleted!`);
              }
              break;
            case UPDATE_SETTING: 
              if (id && stage === environment.stage) {
                console.log(`UPDATE SETTING RESPONSE`);
                console.log(payload);

                this.store.dispatch({
                  type: UPDATE_SETTING,
                  payload: { id, diffList }
                });

                console.log(`MQTT: Setting ${id} updated!`);
              }
              break;
          }
        }),

      this.mqttService
        .templateListener
        .subscribe(({ payload }) => {
          const { type, id, stage } = payload;

          this.store.dispatch({
            type   : SET_TEMPLATE_LIST_VIEW,
            payload: { loading: true }
          });
          this.store.dispatch({
            type   : SET_TEMPLATE_EDIT_FORM,
            payload: { loading: true }
          });

          switch (type) {
            case CREATE_TEMPLATE: 
              if (id && stage === environment.stage) {
                console.log(`CREATE TEMPLATE RESPONSE`);
                console.log(payload);

                this.templateService
                  .getTemplate(id)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { template } = JSON.parse(value.body).data;

                        if (template) {
                          this.store.dispatch({
                            type   : CREATE_TEMPLATE,
                            payload: { template }
                          });

                          console.log(`MQTT: Template ${id} created!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error),
                    ()             => {
                      this.store.dispatch({
                        type   : SET_TEMPLATE_LIST_VIEW,
                        payload: { loading: false }
                      });
                      this.store.dispatch({
                        type   : SET_TEMPLATE_EDIT_FORM,
                        payload: { loading: false }
                      });
                    }
                  )
              }
              break;
            case DELETE_TEMPLATE: 
              if (id && stage === environment.stage) {
                console.log(`DELETE TEMPLATE RESPONSE`);
                console.log(payload);

                this.store.dispatch({
                  type   : SET_TEMPLATE_LIST_VIEW,
                  payload: { loading: true }
                });
                this.store.dispatch({
                  type   : SET_TEMPLATE_EDIT_FORM,
                  payload: { loading: true }
                });

                this.store.dispatch({
                  type   : DELETE_TEMPLATE,
                  payload: { id }
                });

                console.log(`MQTT: Template ${id} deleted!`);

                this.store.dispatch({
                  type   : SET_TEMPLATE_LIST_VIEW,
                  payload: { loading: false }
                });
                this.store.dispatch({
                  type   : SET_TEMPLATE_EDIT_FORM,
                  payload: { loading: false }
                });
              }
              break;
            case UPDATE_TEMPLATE: 
              if (id && stage === environment.stage) {
                console.log(`UPDATE TEMPLATE RESPONSE`);
                console.log(payload);

                this.store.dispatch({
                  type   : SET_TEMPLATE_LIST_VIEW,
                  payload: { loading: true }
                });
                this.store.dispatch({
                  type   : SET_TEMPLATE_EDIT_FORM,
                  payload: { loading: true }
                });

                this.templateService
                  .getTemplate(id)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { template } = JSON.parse(value.body).data;

                        if (template) {
                          this.store.dispatch({
                            type   : UPDATE_TEMPLATE,
                            payload: { template }
                          });

                          console.log(`MQTT: Template ${id} updated!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error),
                    ()             => {
                      this.store.dispatch({
                        type   : SET_TEMPLATE_LIST_VIEW,
                        payload: { loading: false }
                      });
                      this.store.dispatch({
                        type   : SET_TEMPLATE_EDIT_FORM,
                        payload: { loading: false }
                      });
                    }
                  );
              }
              break;
            default: 
              break;
          }
        }),

      this.mqttService
        .userListener
        .subscribe(({ payload }) => {
          const { type, email, stage } = payload;

          this.store.dispatch({
            type   : SET_USER_LIST_VIEW,
            payload: { loading: true, userDetailsLoading: true }
          });

          switch (type) {
            case CREATE_USER: 
              if (email && stage === environment.stage) {
                console.log('CREATE USER RESPONSE');
                console.log(payload);

                this.authService
                  .getUser(email)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { user } = JSON.parse(value.body).data;

                        if (user) {
                          this.store.dispatch({
                            type   : CREATE_USER,
                            payload: { user }
                          });

                          console.log(`MQTT: User ${email} created!`);

                          this.store.dispatch({
                            type   : SET_USER_LIST_VIEW,
                            payload: { selectedUser: email, user, message: this.translate.instant('USER_CREATED', email) }
                          });
                        }
                      }
                    },
                    (error: Error) => console.log(error),
                    ()             => {
                      this.store.dispatch({
                        type   : SET_USER_LIST_VIEW,
                        payload: { loading: false, userDetailsLoading: false }
                      });
                    }
                  );
              }
              break;
            case DELETE_USER: 
              if (email && stage === environment.stage) {
                console.log('DELETE USER RESPONSE');
                console.log(payload);

                this.store.dispatch({
                  type   : SET_USER_LIST_VIEW,
                  payload: { loading: true, userDetailsLoading: true }
                });

                this.store.dispatch({
                  type   : DELETE_USER,
                  payload: { email }
                });

                console.log(`MQTT: User ${email} deleted!`);

                // this.toasterService.pop({
                //   type: 'warning',
                //   title: this.translate.instant('USER_DELETED'),
                //   body: this.translate.instant('USER_DELETED_INFO', [email]),
                //   timeout: 8000
                // });

                let user = null;
                this.userListView
                  .take(1)
                  .subscribe(({ selectedUser }) => {
                    user = selectedUser;

                    this.store.dispatch({
                      type   : SET_USER_LIST_VIEW,
                      payload: {
                        selectedUser      : null,
                        user              : null,
                        loading           : false,
                        error             : this.translate.instant('USER_DELETED', email),
                        userDetailsLoading: false
                      }
                    });
                  });
              }
              break;
            case UPDATE_USER: 
              if (email && stage === environment.stage) {
                console.log('UPDATE USER RESPONSE');
                console.log(payload);

                this.store.dispatch({
                  type   : SET_USER_LIST_VIEW,
                  payload: { loading: true, userDetailsLoading: true }
                });

                this.authService
                  .getUser(email)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { user } = JSON.parse(value.body).data;

                        if (user) {
                          this.store.dispatch({
                            type   : UPDATE_USER,
                            payload: { user }
                          });

                          console.log(`MQTT: User ${email} updated!`);

                          this.store.dispatch({
                            type   : SET_USER_LIST_VIEW,
                            payload: { message: this.translate.instant('USER_UPDATED', email) }
                          });
                        }
                      }
                    },
                    (error: Error) => console.log(error),
                    ()             => {
                      this.store.dispatch({
                        type   : SET_USER_LIST_VIEW,
                        payload: { loading: false, userDetailsLoading: false }
                      });
                    }
                  )
              }
              break;
          }
        }),

      this.eodForm
        .get('lastOfDay')
        .valueChanges
        .subscribe(lastOfDay => {
          console.log(this.eodForm.value);
          if (lastOfDay) {
            this.eodForm.get('nextBusinessDay').enable();
          } else {
            this.eodForm.get('nextBusinessDay').disable();
          }
        }),

      this.orderService
        .getArchivedOrder
        .subscribe(({ id, category }) => {
          if (id && category) {
            console.log(`Could not find client side job/order, querying backend`);
            const prefix = id.slice(0, 2).toLowerCase();

            Observable
              .combineLatest(
                this.orderService.getFullOrder(category === OA && prefix !== OA ? id : `OA${id}`),
                this.orderService.getFullOrder(category === OA && prefix !== OA ? `OA${id}` : id),
                this.orderService.getFullOrderByJobID(id)
              )
              .take(1)
              .subscribe(
                ([ orderResult, archivedOrder, jobOrderResult ]) => {
                  const orderStatusCode = orderResult.statusCode;
                  const archivedOrderStatusCode = archivedOrder.statusCode;
                  const jobOrderStatusCode = jobOrderResult.statusCode;

                  if (orderStatusCode === 200 || jobOrderStatusCode === 200 || archivedOrderStatusCode === 200) {
                    const { fullOrder } = JSON.parse(orderResult.body).data;
                    console.log("order in other system : ", fullOrder);
                    const archOrder = JSON.parse(archivedOrder.body).data.fullOrder;
                    console.log("archivedOrder : ", archOrder);
                    const { fullOrderByJobID } = JSON.parse(jobOrderResult.body).data;
                    if (this.isOrderCompletedOrCancelled(fullOrder) || this.isOrderCompletedOrCancelled(archOrder)) {
                      let order = archOrder ? archOrder : fullOrder;

                      console.log(`Order found: ${JSON.stringify(order, null, 2)}`);
                      if (order.category !== category) {
                        this.toasterService.pop({
                          type: 'info',
                          title  : this.translate.instant('ORDER_FOUND_WRONG_SYSTEM'),
                          body   : `<div>${this.translate.instant('ORDER_FOUND_WRONG_SYSTEM_INFO1', id)}</div>
                          <ul>
                            <li>${this.translate.instant('ORDER_FOUND_WRONG_SYSTEM_INFO2', (this.process).toUpperCase())}</li>
                            <li>${this.translate.instant('ORDER_FOUND_WRONG_SYSTEM_INFO3', order.category.toUpperCase())}</li>
                          </ul>`,
                          bodyOutputType: BodyOutputType.TrustedHtml,
                          timeout: 15000
                        });
                      } else {
                        this.store.dispatch({
                          type   : CREATE_JOBS,
                          payload: { jobs: order.jobs }
                        });
  
                        const formattedOrder = Object.assign({}, order, {
                          jobs: order.jobs.map(job => job.id),
                          status: order.status || order.jobs[0].status // Take job status which should be synced to order, if order status doesn't exist
                        });
  
                        this.store.dispatch({
                          type   : CREATE_ORDER,
                          payload: { order: formattedOrder }
                        });

                        let homepageRoute = '';
                        if(category === OA){
                          homepageRoute = `oa/dashboard/orders/all`;
                        }else if(category === RFID){
                          homepageRoute = `rfid/dashboard/orders/all`;
                        }else{
                          homepageRoute = `dashboard/orders/all`;
                        }

                        this.router.navigate([
                          // category === OA ? `oa/dashboard/orders/all` : `dashboard/orders/all`, 
                          homepageRoute, 
                          order.id
                        ]);
                      }
                    } else if (this.isOrderCompletedOrCancelled(fullOrderByJobID)) {
                      console.log(`Order found by job id: ${JSON.stringify(fullOrderByJobID, null, 2)}`);

                      if (fullOrderByJobID.category !== category) {
                        this.toasterService.pop({
                          type: 'info',
                          title  : this.translate.instant('ORDER_FOUND_WRONG_SYSTEM'),
                          body   : `<div>${this.translate.instant('ORDER_FOUND_WRONG_SYSTEM_INFO1', id)}</div>
                          <br />
                          <div>${this.translate.instant('ORDER_FOUND_WRONG_SYSTEM_INFO2', (this.process).toUpperCase())}</div>
                          <div>${this.translate.instant('ORDER_FOUND_WRONG_SYSTEM_INFO3', fullOrderByJobID.category.toUpperCase())}</li>`,
                          bodyOutputType: BodyOutputType.TrustedHtml,
                          timeout: 15000
                        });
                      } else {
                        const job = fullOrderByJobID.jobs.find(job => job.id === id);
  
                        this.store.dispatch({
                          type   : CREATE_JOBS,
                          payload: { jobs: fullOrderByJobID.jobs }
                        });
  
                        const formattedOrder = Object.assign({}, fullOrderByJobID, {
                          jobs: fullOrderByJobID.jobs.map(job => job.id),
                          status: fullOrderByJobID.status || fullOrderByJobID.jobs[0].status
                        });
  
                        this.store.dispatch({
                          type   : CREATE_ORDER,
                          payload: { order: formattedOrder }
                        });

                        let homepageRoute = '';
                        if(category === OA){
                          homepageRoute = 'oa/dashboard/jobs';
                        }else if(category === SHEETS){
                          homepageRoute = 'dashboard/jobs';
                        }else{
                          homepageRoute = 'rfid/dashboard/jobs';
                        }
  
                        this.router.navigate([
                          // category === OA ? 'oa/dashboard/jobs' : 'dashboard/jobs', 
                          homepageRoute,
                          job.status, 
                          job.id
                        ]);
                      }
                    } else {
                      console.log(`Could not find order/job from ID: ${id}`);
                      if(!this.router.url.includes('/dashboard/shipping/all/')){
                        this.toasterService.pop({
                          type   : 'error',
                          title  : this.translate.instant('NO_SEARCH_RESULTS'),
                          body   : this.translate.instant('NO_SEARCH_RESULTS_INFO', id),
                          timeout: 12000
                        });
                      }
                    }
                  }
                },
                (error: Error) => console.log(error)
              )
          }
        }),

      this.scanner
        ._locationListener
        .subscribe(id => {
          const ID       = id.replace(/[^A-Za-z0-9-]/g, '');
          const [ l, t ] = this.scanner._triggers;
          const location = this.scanner._locations[l];
          const type     = this.scanner._types[t];
          console.log(`Barcode scanned`);
          console.log({
            'ID'      : ID,
            'Location': location,
            'Type'    : type
          });

          if (this.process === SHEETS) {
            // Sheets scan
            if (location !== BATCH_CUTTING) {
              Observable
                .combineLatest(
                  this.jobList,
                  this.orderList,
                  this.shipmentList
                )
                .take(1)
                .subscribe(([ jobs, orders, shipments ]) => {
                  if (type === HANDHELD) {
                    console.log(`Handheld Scan`);
                    const order = orders.find(order => order.id === ID);
                    const job   = jobs.find(job => job.id === ID);
                    const shipment = shipments.find(shipment => (order && shipment.orderId === order.id) || (job && shipment.orderId === job.orderId));
                    const oneNonShippingJob = shipment ? !!jobs.filter(job => (<any>shipment.jobs).includes(job.id)).find(job => job.status != "shipping") : false;
                    const orderByJobScan = job && orders.find(order => order.id === job.orderId);
                    //console.log('orderByJobScan', orderByJobScan)
                    //console.log('shipment', shipment)

                    if (location === SHIPMENTS && orderByJobScan && orderByJobScan.jobs && orderByJobScan.jobs.length === 1) {
                      if(shipment){
                        let shipmentRoute = '/dashboard/shipping/all/' + shipment.id
                        if(this.router.url != shipmentRoute){
                          if(shipment.shipmentStatus == NEW){
                            this.router.navigate(['dashboard/shipping/all', shipment.id]);
                            this.QaOkayModalRef = this.modalService.show(QaOkayModal, {
                              animated: false,
                              class   : 'modal-xxl',
                              initialState : { order: order || orderByJobScan, jobs: [job], shipment: shipment }
                            }); 
                          }else{
                            this.router.navigate(['dashboard/shipping/all', shipment.id]);
                          }
                        }
                      }else{
                        if((job.product && job.product.description === 'labels') && (job.status === PRINTED || job.status === PRINT_READY)) { //Bring up Sheet Count - for only LABELS
                          if(!job.reprint) {
                            this.sheetCountModalRef = this.modalService.show(SheetCountModal, {
                              animated: false,
                              class   : 'modal-lg sheet-count-modal',
                              initialState : { job: job, order: order || orderByJobScan, shipment: shipment}
                            })
                          } else {
                            let allReprints = job.activity_history.filter((ah) => {
                              if(ah.activity === 'queued') {
                                return ah.note.includes('Reprint');
                              }
                            }).sort((a,b)=> Number(b.timestamp) - Number(a.timestamp));
                            let lastReprintEditado = allReprints[0].note.includes('|Editado|');
                            if(lastReprintEditado) {
                              console.log('EDITADO MODAL')
                              this.sheetCountModalRef = this.modalService.show(EditadoSheetQaModal, {
                                animated: false,
                                class   : 'modal-lg',
                                initialState : { job: job, order: order || orderByJobScan, shipment: shipment, reprint: allReprints[0].note}
                              });
                            } else {
                              if(job.status === PRINT_READY) {
                                this.orderService.setJobStatus(job, PRINTED);  
                              }
                              this.sheetCountModalRef = this.modalService.show(SheetCountModal, {
                                animated: false,
                                class   : 'modal-lg sheet-count-modal',
                                initialState : { job: job, order: order || orderByJobScan, shipment: shipment}
                              });
                            }
                          }
                        }else{ //Update to shipment dont require sheet count ex. cards, tags, etc
                          if(job.status == PRINTED && !shipment){
                            this.orderService.setJobStatus(job, SHIPMENTS);
                          }
                        }
                      }
                    }else{
                      if (order && oneNonShippingJob) {
                        this.router.navigate(['dashboard/orders/all', order.id]);
                      } else if (job && oneNonShippingJob) {
                        this.router.navigate(['dashboard/jobs', job.status, job.id]);
                      } else if ((shipment && !oneNonShippingJob) || (shipment && !order && !job)) {
                        this.router.navigate(['dashboard/shipping/all', shipment.id]);
                      } else {
                        this.orderService.getArchivedOrder.next({ id: ID, category: SHEETS });
                      } 
                    }
                  } else if (type === STATIONARY) { //Bin Station
                    console.log(`Stationary Scan`);
                    const job   = jobs.find(job => job.id === ID);
                    const order = job && orders.find(order => order.id === job.orderId);
                    const next  = nextStatus[location];
                    console.log(order);
                    console.log('next : ',next);
                    if (next && job && order) {
                      console.log("Allowable Job ", allowJobScan[job.status])
                      if(order.status !== EOD_COMPLETED && order.status !== CANCELLED && allowJobScan[job.status]) {
                        const shipment = shipments.find(shipment => (order && shipment.orderId === order.id) || (job && shipment.orderId === job.orderId));
                        this.sheetEstimate = '';

                        if(next.next === 'shipping' && shipment) {
                          this.router.navigate(['dashboard/shipping/all', shipment.id]);
                          if(job.product && job.product.description === 'labels' && (job.status === PRINTED || job.status === PRINT_READY)) {
                            if(order.status === PENDING_PRINTING) {
                              this.pendingPrintingCsModalRef = this.modalService.show(PendingPrintCsModal, {
                                animated: false
                              });
                            } else {
                              if(!job.reprint) {
                                if(job.status === PRINT_READY) {
                                  this.orderService.setJobStatus(job, PRINTED);  
                                }
                                this.sheetCountModalRef = this.modalService.show(SheetCountModal, {
                                  animated: false,
                                  class   : 'modal-lg sheet-count-modal',
                                  initialState : { job: job, order: order, shipment: shipment }
                                });
                              } else {
                                this.router.navigate(['dashboard/jobs', next.next, job.id]);
                                let allReprints = job.activity_history.filter((ah) => {
                                  if(ah.activity === 'queued') {
                                    return ah.note.includes('Reprint');
                                  }
                                }).sort((a,b)=> Number(b.timestamp) - Number(a.timestamp));
                                let lastReprintEditado = allReprints[0].note.includes('|Editado|');
                                if(lastReprintEditado) {
                                  console.log('EDITADO MODAL')
                                  this.sheetCountModalRef = this.modalService.show(EditadoSheetQaModal, {
                                    animated: false,
                                    class   : 'modal-lg',
                                    initialState : { job: job, order: order, shipment: shipment, reprint: allReprints[0].note}
                                  });
                                } else {
                                  if(job.status === PRINT_READY) {
                                    this.orderService.setJobStatus(job, PRINTED);  
                                  }
                                  this.sheetCountModalRef = this.modalService.show(SheetCountModal, {
                                    animated: false,
                                    class   : 'modal-lg sheet-count-modal',
                                    initialState : { job: job, order: order, shipment: shipment }
                                  });
                                }
                              }
                            }

                          }
                        } else {
                          this.router.navigate(['dashboard/jobs', next.next, job.id]);
                          if(next.next === SHIPMENTS && (job.product && job.product.description === 'labels') && (job.status === PRINTED || job.status === PRINT_READY)) {
                            if(order.status === PENDING_PRINTING) {
                              this.pendingPrintingCsModalRef = this.modalService.show(PendingPrintCsModal, {
                                animated: false
                              });
                            } else {
                              if(!job.reprint) {
                                this.sheetCountModalRef = this.modalService.show(SheetCountModal, {
                                  animated: false,
                                  class   : 'modal-lg sheet-count-modal',
                                  initialState : { job: job, order: order, shipment: shipment}
                                });
                              } else {
                                let allReprints = job.activity_history.filter((ah) => {
                                  if(ah.activity === 'queued') {
                                    return ah.note.includes('Reprint');
                                  }
                                }).sort((a,b)=> Number(b.timestamp) - Number(a.timestamp));
                                let lastReprintEditado = allReprints[0].note.includes('|Editado|');
                                if(lastReprintEditado) {
                                  console.log('EDITADO MODAL')
                                  this.sheetCountModalRef = this.modalService.show(EditadoSheetQaModal, {
                                    animated: false,
                                    class   : 'modal-lg',
                                    initialState : { job: job, order: this.order, shipment: shipment, reprint: allReprints[0].note}
                                  });
                                } else {
                                  if(job.status === PRINT_READY) {
                                    this.orderService.setJobStatus(job, PRINTED);  
                                  }
                                  this.sheetCountModalRef = this.modalService.show(SheetCountModal, {
                                    animated: false,
                                    class   : 'modal-lg sheet-count-modal',
                                    initialState : { job: job, order: order, shipment: shipment }
                                  });
                                }
                              }
                            }
                          } else {
                            if(next.next === SHIPMENTS){
                              if(order && order.jobs.length > 1 && !shipment){ //More than one jobs and no shipment
                                
                                this.jobShipFlagView
                                .take(1)
                                .subscribe( (jobShipFlagState) => {
                                  const { shipFlag } = jobShipFlagState;
                            
                                  console.log('Store JobShip flag : ',shipFlag)
                                  this.jobShipFlag = shipFlag;
                                  
                                })
                                
                                if(!this.jobShipFlag){
                                  this.orderService.setJobStatus(job, next.next);
                                }

                                this.store.dispatch({
                                  type   : SET_JOB_SHIP_FLAG,
                                  payload: { shipFlag: true }
                                });
  
                              }else{
                                this.orderService.setJobStatus(job, next.next);
                              }        
                            }else{
                              this.orderService.setJobStatus(job, next.next);
                            }
                          }
                        }
                      } else {
                        // this.router.navigate(['dashboard/jobs', job.status, job.id]);
                        this.scanErrJob = job;
                        if(job.status === HOLD) {
                          const result = job.activity_history.sort((a,b)=> Number(b.timestamp) - Number(a.timestamp)).find(obj=> obj.activity === 'hold');
                          if(job.status === HOLD) {
                            this.scanErrJobHoldReason = (result) ? result : null;
                          }
                        }
                        // console.log('scan Err Job : ',this.scanErrJob);
                        // console.log(`Location : ${location} , shipment status : ${this.shipment ? this.shipment.shipmentStatus : null} , user : ${this.authService.getCurrentUser()}`)
                        try{
                          const invalidJobScan = {
                            id : 1,
                            jobId: job.id,
                            orderId: job.orderId,
                            category: job.category,
                            location: location,
                            jobStatus: job.status,
                            shipmentStatus: this.shipment ? this.shipment.shipmentStatus : null,
                            user: this.authService.getCurrentUser()
                          };
                          console.log(`Invalid Job Scan : ${JSON.stringify(invalidJobScan)}`);
                          this.orderService.createInvalidJobScan(invalidJobScan);
                        } catch (err){
                          console.log(`Invalid Job Scan Error : ${JSON.stringify(err)}`);
                        }
                        this.invalidScanModalRef   = this.modalService.show(this.invalidScanModal, {
                          animated: false,
                          class : 'modal-lg'
                        });
                      }
                    } else {
                      this.orderService.getFullOrderByJobID(ID).subscribe(jobOrderResult=> {
                        const jobOrderStatusCode = jobOrderResult.statusCode;
                        if (jobOrderStatusCode === 200) {
                          const { fullOrderByJobID } = JSON.parse(jobOrderResult.body).data;
                          if (fullOrderByJobID) {
                            const job = fullOrderByJobID.jobs.find(job => job.id === ID);
                            const formattedOrder = Object.assign({}, fullOrderByJobID, {
                              jobs: fullOrderByJobID.jobs.map(job => job.id)
                            });
                            if(job.status === EOD_COMPLETED || job.status === CANCELLED) {
                              // this.router.navigate(['dashboard/jobs', job.status, job.id]);
                              this.scanErrJob = job;
                              // console.log(`Location : ${location} , shipment status : ${this.shipment ? this.shipment.shipmentStatus : null} , user : ${this.authService.getCurrentUser()}`)
                              try{
                                const invalidJobScan = {
                                  id : 1,
                                  jobId: job.id,
                                  orderId: job.orderId,
                                  category: job.category,
                                  location: location,
                                  jobStatus: job.status,
                                  shipmentStatus: this.shipment ? this.shipment.shipmentStatus : null,
                                  user: this.authService.getCurrentUser()
                                };
                                console.log(`Invalid Job Scan : ${JSON.stringify(invalidJobScan)}`);
                                this.orderService.createInvalidJobScan(invalidJobScan);
                              } catch (err){
                                console.log(`Invalid Job Scan Error : ${JSON.stringify(err)}`);
                              }
                              this.invalidScanModalRef   = this.modalService.show(this.invalidScanModal, {
                                animated: false,
                                class : 'modal-lg'
                              });
                            }
                          } 
                        }
                      });
                    }
                  }
                });
            }
          } else if(this.process === OA){
            if (this.scanner.isExclusiveMode()) {
              console.log('Scanner in exclusive mode, skipping global scan handling');
              return;
            }

            // Online Aisle scan
            this.batchListView
              .take(1)
              .subscribe(batchListView => {
                const { cuttingView } = batchListView;
                console.log(batchListView)
                console.log("cuttingView: ",cuttingView);
                if (cuttingView && location === BATCH_CUTTING) {
                  console.log("Moving on to batch cutting listener", ID);
                  this.scanner._batchCuttingListener.next(ID);
                } else if (!cuttingView) {
                  if (ID.includes('-')) {
                    // Work order scan
                    console.log(`Work order datamatrix scanned`);
                    const [ orderID, jobID ] = ID.split('-');
                    console.log(`Order "${orderID}", Job "${jobID}"`);

                    if (orderID && jobID) {
                      Observable
                        .combineLatest(
                          this.jobList,
                          this.shipmentList
                        )
                        .take(1)
                        .subscribe(([ jobs, shipments ]) => {
                          const job = jobs.find(job => job.id === jobID);
                          const shipment = shipments.find(shipment => shipment.orderId === orderID);
                          const oneNonShippingJob = shipment ? !!jobs.filter(job => (<any>shipment.jobs).includes(job.id)).find(job => job.status != "shipping") : false;

                          if (shipment && !oneNonShippingJob) {
                            // console.log('navigate to shipment')
                            this.router.navigate(['oa/dashboard/shipping/all', shipment.id]);
                          } else if (job && job.orderId === orderID) {
                            console.log('navigate to job status and job.id',job)
                            this.router.navigate(['oa/dashboard/jobs', job.status, job.id]);
                            if(job.status === CUT && location === CUT) {
                              // console.log(next);
                              // console.log(location);
                              // console.log('next : ',next);
                              // const next  = nextOAStatus[location];
                              this.orderService.openPackingModal.next({ id: job.id, status: job.status });
                              // this.orderService.setJobStatus(job, next.next);
                            }
                          }
                        });
                    }
                  } else {
                    Observable
                      .combineLatest(
                        this.jobList,
                        this.orderList,
                        this.shipmentList
                      )
                      .take(1)
                      .subscribe(([ jobs, orders, shipments ]) => {
                        if (type === HANDHELD) {
                          console.log(`Handheld Scan`);
                          const prefix = ID.slice(0, 2).toUpperCase();
                          const order = orders.find(order => {
                            return prefix === OA
                              ? order.id === ID
                              : order.id === `OA${ID}`;
                          });
                          const job   = jobs.find(job => job.id === ID);
                          const shipment = shipments.find(shipment => (order && shipment.orderId === order.id) || (job && shipment.orderId === job.orderId));
                          const oneNonShippingJob = shipment ? !!jobs.filter(job => (<any>shipment.jobs).includes(job.id)).find(job => job.status != "shipping") : false;
          
                          if (order && oneNonShippingJob) {
                            this.router.navigate(['oa/dashboard/orders/all', order.id]);
                          } else if (job && oneNonShippingJob) {
                            this.router.navigate(['oa/dashboard/jobs/all', job.id]);
                          } else if ((shipment && !oneNonShippingJob) || (shipment && !order && !job)) {
                            this.router.navigate(['oa/dashboard/shipping/all', shipment.id]);
                          } else {
                            this.orderService.getArchivedOrder.next({ id: ID, category: OA });
                          }
                        } else if (type === STATIONARY) {
                          console.log(`Stationary Scan`);
                          const job   = jobs.find(job => job.id === ID);
                          const order = job && orders.find(order => order.id === job.orderId);
                          const next  = nextOAStatus[location];
                          console.log(order)
                          if (next && job && order) {
                            console.log("Allowable Job ", allowJobScan[job.status])
                            if(order.status !== EOD_COMPLETED && order.status !== CANCELLED && allowJobScan[job.status]) {
                              const shipment = shipments.find(shipment => (order && shipment.orderId === order.id) || (job && shipment.orderId === job.orderId));
                              this.orderService.setJobStatus(job, next.next);
                              if(next.next === 'shipping' && shipment) {
                                this.router.navigate(['oa/dashboard/shipping/all', shipment.id]);
                              } else {
                                this.router.navigate(['oa/dashboard/jobs', next.next, job.id]);
                              }
                            } else {
                              // this.router.navigate(['dashboard/jobs', job.status, job.id]);
                              this.scanErrJob = job;
                              if(job.status === HOLD) {
                                const result = job.activity_history.sort((a,b)=> Number(b.timestamp) - Number(a.timestamp)).find(obj=> obj.activity === 'hold');
                                if(job.status === HOLD) {
                                  this.scanErrJobHoldReason = (result) ? result : null;
                                }
                              }
                              console.log(`Location : ${location} , shipment status : ${this.shipment ? this.shipment.shipmentStatus : null} , user : ${this.authService.getCurrentUser()}`)
                              try{
                                const invalidJobScan = {
                                  id : 1,
                                  jobId: job.id,
                                  orderId: job.orderId,
                                  category: job.category,
                                  location: location,
                                  jobStatus: job.status,
                                  shipmentStatus: this.shipment ? this.shipment.shipmentStatus : null,
                                  user: this.authService.getCurrentUser()
                                };
                                console.log(`Invalid Job Scan : ${JSON.stringify(invalidJobScan)}`);
                                this.orderService.createInvalidJobScan(invalidJobScan);
                              } catch (err){
                                console.log(`Invalid Job Scan Error : ${JSON.stringify(err)}`);
                              }
                              this.invalidScanModalRef   = this.modalService.show(this.invalidScanModal, {
                                animated: false,
                                class : 'modal-lg'
                              });
                            }
                          } else {
                            this.orderService.getFullOrderByJobID(ID).subscribe(jobOrderResult=> {
                              const jobOrderStatusCode = jobOrderResult.statusCode;
                              console.log(jobOrderStatusCode)
                              if (jobOrderStatusCode === 200) {
                                const { fullOrderByJobID } = JSON.parse(jobOrderResult.body).data;
                                if (fullOrderByJobID) {
                                  const job = fullOrderByJobID.jobs.find(job => job.id === ID);
                                  const formattedOrder = Object.assign({}, fullOrderByJobID, {
                                    jobs: fullOrderByJobID.jobs.map(job => job.id)
                                  });
                                  if(job.status === EOD_COMPLETED || job.status === CANCELLED) {
                                    // this.router.navigate(['dashboard/jobs', job.status, job.id]);
                                    this.scanErrJob = job;
                                    console.log(`Location : ${location} , shipment status : ${this.shipment ? this.shipment.shipmentStatus : null} , user : ${this.authService.getCurrentUser()}`)
                                    try{
                                      const invalidJobScan = {
                                        id : 1,
                                        jobId: job.id,
                                        orderId: job.orderId,
                                        category: job.category,
                                        location: location,
                                        jobStatus: job.status,
                                        shipmentStatus: this.shipment ? this.shipment.shipmentStatus : null,
                                        user: this.authService.getCurrentUser()
                                      };
                                      console.log(`Invalid Job Scan : ${JSON.stringify(invalidJobScan)}`);
                                      this.orderService.createInvalidJobScan(invalidJobScan);
                                    } catch (err){
                                      console.log(`Invalid Job Scan Error : ${JSON.stringify(err)}`);
                                    }
                                    this.invalidScanModalRef   = this.modalService.show(this.invalidScanModal, {
                                      animated: false,
                                      class : 'modal-lg'
                                    });
                                  }
                                } 
                              }
                            });
                          }

                        }
                      })
                  }
                }
              });
          } else if(this.process === RFID){
            console.log('RFID Scan')
            // Skip processing if scanner is in exclusive mode
            if (this.scanner.isExclusiveMode()) {
              console.log('Scanner in exclusive mode, skipping global scan handling');
              return;
            }
            
            if (type === STATIONARY) {
              if (ID.includes('-')) {
                // Inner case label scan
                console.log(`Inner case label scanned`);
                const [ orderID, jobID ] = ID.split('-');
                console.log(`Order "${orderID}", Job "${jobID}"`);

                if (orderID && jobID) {
                  Observable
                    .combineLatest(
                      this.jobList,
                      this.shipmentList
                    )
                    .take(1)
                    .subscribe(([ jobs, shipments ]) => {
                      const job = jobs.find(job => job.id === jobID);
                      const shipment = shipments.find(shipment => shipment.orderId === orderID);
                      const oneNonShippingJob = shipment ? !!jobs.filter(job => (<any>shipment.jobs).includes(job.id)).find(job => job.status != "shipping") : false;

                      if (shipment && !oneNonShippingJob) {
                        // console.log('navigate to shipment')
                        this.router.navigate(['rfid/dashboard/shipping/all', shipment.id]);
                      } else if (job && job.orderId === orderID) {
                        console.log('navigate to job status and job.id',job)
                        this.router.navigate(['rfid/dashboard/jobs', job.status, job.id]);
                      }else{
                        console.log('Invalid scanning at inner case label')
                      }
                    });
                }
              }
            }
          }
        }),

      this.shipmentService
        .displayShipmentDetails
        .subscribe(({ class: _class, title, body }) => {
          this.globalModalTitle = title;
          this.globalModalBody  = body;
          this.globalModalClass = _class;
          this.globalModalRef   = this.modalService.show(this.globalModal, {
            animated: false,
            class: 'shipment-complete-modal'
          });
        }),
      
      this.jobService
        .displayJobDetails
        .subscribe(({ class: _class, title, modalBody }) => {
          this.globalModalTitle = title;
          this.globalModalBody  = modalBody;
          this.globalModalClass = _class;
          this.globalModalRef   = this.modalService.show(this.globalModal, {
            animated: false,
            class: 'qa-bin-modal'
          });
        }),

      this.shipmentService
        .boxingStationPrompt
        .subscribe(({ shipment, order, jobs }) => {
          this.shipment            = shipment;
          this.order               = order;
          this.jobs                = jobs;
          this.boxingStationToggle = false;

          this.setBoxingStationFormValues(this.shipment, this.order, this.jobs);
          this.boxingStationPromptRef = this.modalService.show(
            this.boxingStationPrompt,
            {
              animated: false,
              backdrop: 'static',
              class   : 'modal-lg'
            }
          );
        }),

      this.shipmentService
        .openIntlInvoiceModal
        .subscribe(intlShipment => {
          this.intlShipment = intlShipment;
          this.invoiceDone = false;

          this.intlInvoiceConfirmModalRef = this.modalService.show(
            this.intlInvoiceConfirmModal,
            {
              animated: false,
              backdrop: 'static',
              class   : 'modal-lg'
            }
          );
        }),

      this.shipmentService
        .processEOD
        .subscribe(() => {
          const today           = moment();
          const nextBusinessDay = this.getNextBusinessDay();

          console.log(`Next business day: ${nextBusinessDay.format('YYYY-MM-DD')}`);

          this.datePickerOptions = {
            dateFormat  : 'yyyy-mm-dd',
            disableUntil: {
              year : today.year(),
              month: today.month() + 1,
              day  : +today.format('D')
            },
            selectorHeight      : '260px',
            selectorWidth       : '282px',
            selectionTxtFontSize: '20px',
            width               : '17rem'
          };

          this.eodForm.patchValue({
            nextBusinessDay: {
              date: {
                year : nextBusinessDay.year(),
                month: nextBusinessDay.month() + 1,
                day  : +nextBusinessDay.format('D')
              }
            }
          });

          this.eodModalRef = this.modalService.show(
            this.eodModal,
            {
              animated: false,
              backdrop: 'static',
              class   : 'modal-lg'
            }
          );
        }),

      this.mainView
        .subscribe(mainView => {
          const { eodProcessing, eodOAProcessing, shippingConfig } = mainView;
          console.log("🚀 ~ AppComponent ~ ngOnInit ~ shippingConfig:", shippingConfig)

          this.eodProcessing   = eodProcessing;
          this.eodOAProcessing = eodOAProcessing;
          if (shippingConfig) {
            this.eodForm.patchValue({ carrier: shippingConfig });
          } else {
            this.eodForm.patchValue({ carrier: null });
          }
        }),

      Observable
        .combineLatest(
          this.batchList,
          this.shipmentList,
          this.mailInnovationsOrderList
        )
        .subscribe(([ batches, shipments, mailInnovationsOrders ]) => {
          this.batchesMissingScrap = batches.filter(batch => batch.batchStatus === COMPLETED && !batch.designatedScrap);
          this.unassignedMIDOrders = !!mailInnovationsOrders.length;
          this.shipmentsReady      = !!shipments.find(shipment => shipment.shipmentStatus === SHIPPED || shipment.shipmentStatus === EOD_FAILED);
          this.eodReady            = this.process !== OA
            ? this.shipmentsReady && !this.unassignedMIDOrders 
            : this.shipmentsReady && !this.batchesMissingScrap.length && !this.unassignedMIDOrders;
        }),

      
    ];
  }

  ngOnDestroy(): void {
    this.initSubscriptions.forEach(subscription => subscription.unsubscribe());
    !!this.boxingStationPromptRef && this.boxingStationPromptRef.hide();
    !!this.eodModalRef && this.eodModalRef.hide();
    !!this.intlInvoiceConfirmModalRef && this.intlInvoiceConfirmModalRef.hide();
    !!this.globalModalRef && this.globalModalRef.hide();
  }

  createForms(): void {
    const currentCarrier = this.settingService.getShippingConfig();

    this.boxingStationForm = this.fb.group({
      holdReason : [null, Validators.required],
      otherReason: [null],
      jobs       : this.fb.array([])
    });
    // console.log('***************************** This. OA : ', this.oa)
    this.eodForm = this.fb.group({
      lastOfDay      : [null, Validators.required],
      nextBusinessDay: [{ value: null, disabled: true }, Validators.required],
      carrier        : [{value: currentCarrier}, Validators.required],
    });
  }

  closeGlobalModal() {
    this.globalModalRef.hide();
  }
  // dateChanged(date: IMyDateModel): void {
  //   console.log(`new date: ${JSON.stringify(date, null, 2)}`);
  // }

  getNextBusinessDay(): any {
    // Business days: Monday - Saturday
    const today = moment().format('ddd');

    return today === 'Sat'
      ? moment().add(2, 'days')
      :  moment().add(1, 'days');
  }

  hideEODModal(): void {
    !!this.eodModalRef && this.eodModalRef.hide();

    // this.eodForm.patchValue({ lastOfDay: null, amazonDf: this.oa ? null : false });
    this.eodForm.patchValue({ lastOfDay: null });
  }

  holdOrderAndJobs(event: Event): void {
    event.stopPropagation();

    const holdReason  = this.boxingStationForm.value.holdReason;
    const otherReason = this.boxingStationForm.value.otherReason;

    if (this.boxingStationForm.invalid || (holdReason === OTHER && !otherReason)) return;

    !!this.boxingStationPromptRef && this.boxingStationPromptRef.hide();
    this.boxingStationToggle = false;

    const jobIDs = this.boxingStationForm.value.jobs
      .filter(job => job.hold)
      .map(job => job.id);

    this.jobList
      .take(1)
      .subscribe(jobs => {
        const jobsToUpdate = jobs.filter(job => jobIDs.find(id => id === job.id));

        this.orderService.setJobStatuses(
          jobsToUpdate,
          HOLD,
          holdReason || otherReason
        );
        // this.orderService.updateOrderStatus(
        //   this.order,
        //   jobsToUpdate,
        //   HOLD,
        //   holdReason || otherReason
        // );
      });
  }

  jobsValidator(control: AbstractControl): any {
    let valid = false;
    control['controls'].forEach(formControl => {
      if (formControl.value.hold) {
        valid = true;
      }
    });

    return valid ? null: { atLeastOneSelected: false };
  }

  processEOD(): void {
    !!this.eodModalRef && this.eodModalRef.hide();

    const ready = this.eodReady;
    let processing;

    switch(this.process){
      case OA:
        processing = this.eodOAProcessing;
        break;
      case SHEETS:
        processing = this.eodProcessing;
        break;
      case RFID:
        processing = this.eodRFIDProcessing;
        break;
    }

    const invalid = this.eodForm.invalid;
    const target  = this.process;

    console.log(`Processing EOD for ${target}`);
    console.log(`eod processing... ${processing}`);
    console.log(`eod ready... ${ready}`); 
    console.log(`form valid... ${invalid}`);

    if (processing || !ready || invalid) {
      console.log(`Can't run EOD process right now`);
      return;
    }

    console.log(`EOD process trigger`);
    const { lastOfDay, nextBusinessDay, carrier} = this.eodForm.value;


    if (!lastOfDay) {
      switch(this.process)  {
        case OA:
          this.store.dispatch({
            type   : SET_MAIN_VIEW,
            payload: { eodOAProcessing: true }
          });
          break;
        case SHEETS:
          this.store.dispatch({
            type   : SET_MAIN_VIEW,
            payload: { eodProcessing: true }
          });
          break;
        case RFID:
          this.store.dispatch({
            type   : SET_MAIN_VIEW,
            payload: { eodRFIDProcessing: true }
          });
          break;
      }

      this.eodService.processEOD(null, target, lastOfDay, carrier);

      // this.eodForm.patchValue({ lastOfDay: null, amazonDf : this.oa ? null : false });
      this.eodForm.patchValue({ lastOfDay: null });
    } else {
      console.log(`last eod of day indicated!`);

      const { date } = nextBusinessDay;

      this.settingList
        .take(1)
        .subscribe(
          settings => {
            const settingName = this.process === OA ? 'SYSTEM.SETTING.NEXT_BUSINESS_DAY_OA.NAME' : 
                                this.process === RFID ? 'SYSTEM.SETTING.NEXT_BUSINESS_DAY_RFID.NAME' : 
                                this.process === SHEETS ? 'SYSTEM.SETTING.NEXT_BUSINESS_DAY.NAME' : '';
            const nextBusinessDaySetting = settings.find(setting => setting.name === settingName);
            // const eodSetting = settings && settings.find(setting => setting.name === 'SYSTEM.SETTING.ENABLE_EOD.NAME');
            // this.allowEod = eodSetting ? (eodSetting.value === 'true' ? true : false) : false;
            console.log(`next business day setting: ${JSON.stringify(nextBusinessDaySetting, null, 2)}`);

            if (nextBusinessDaySetting) {
              const { value } = nextBusinessDaySetting;

                    date.month    = date.month - 1;
              const formattedDate = moment(date).format('YYYY-MM-DD');

              console.log(`next business day is currently set to: ${value}`);
              console.log(`next business day is being changed to: ${formattedDate}`);

              if (value !== formattedDate) {
                const updatedSetting = Object.assign({}, nextBusinessDaySetting, {
                  value: formattedDate
                });

                this.settingService.updateSetting(updatedSetting);
              }
            }
          },
          error => console.log(error),
          ()    => {
            switch(this.process){
              case OA:
                this.store.dispatch({
                  type   : SET_MAIN_VIEW,
                  payload: { eodOAProcessing: true }
                });
                break;
              case SHEETS:
                this.store.dispatch({
                  type   : SET_MAIN_VIEW,
                payload: { eodProcessing: true }
                });
                break;
              case RFID:
                this.store.dispatch({
                  type   : SET_MAIN_VIEW,
                  payload: { eodRFIDProcessing: true }
                });
                break;
            }

            this.eodService.processEOD(null, target, lastOfDay, carrier);

            this.eodForm.patchValue({ lastOfDay: null });
          }
        );
    }
  }

  reprintInvoice(intl: any): void {
    const { intlInvoice, orderId } = intl;
    // console.log("REPRINTING: ",intl)
    this.printerService.printIntlInvoice(intlInvoice, orderId);
  }

  setBoxingStationFormValues(shipment: any, order: any, jobs: any) {
    const jobList = jobs.map(job => this.fb.group({
      hold       : [false],
      id         : [job.id],
      material   : [job.product.material_description || ''],
      name       : [job.descriptiveName],
      qty_ordered: [job.qty]
    }));

    this.boxingStationForm.setControl('jobs', this.fb.array(jobList, this.jobsValidator));
  }

  setShipmentReady(event: Event): void {
    event.stopPropagation();

    this.boxingStationPromptRef.hide();
    this.boxingStationToggle = false;

    const activity: ActivityHistory = {
      activity  : "qa Ok",
      note      : null,
      user      : this.authService.getCurrentUser(),
      timestamp : (new Date).getTime().toString(),
      comment   : null,
    };
    if(this.shipment.activity_history && Array.isArray(this.shipment.activity_history)) {
      this.shipment.activity_history.unshift(activity);
    } else {
      this.shipment.activity_history = [activity]
    }
    this.shipmentService.qaCheckOK(this.shipment);
  }

  toggleBoxingModalView(toggle: boolean): void {
    this.boxingStationToggle = toggle;
  }

  isOrderCompletedOrCancelled(order) {
    
    // Check if order status is EOD_COMPLETED or CANCELLED
    if (order && (order.status === EOD_COMPLETED || order.status === CANCELLED)) {
      return true;
    }
    
    // Check if any job in the jobs array has jobStatus EOD_COMPLETED or CANCELLED
    if (order && Array.isArray(order.jobs)) {
      return order.jobs.some(job => job.status === EOD_COMPLETED || job.status === CANCELLED);
    }
    
    return false;
  }
  
}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/app.component.ts